var map = {
	"./bad-32.png": "XCcF",
	"./good-32.png": "lsTC",
	"./okay-32.png": "oWss",
	"./very bad-32.png": "dN3Y",
	"./very good-32.png": "Ti5Q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5n7E";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emojis ^\.\/.*\-32\.png$
// module id = 5n7E
// module chunks = 1